/**
 * ==========================================================
 * @description: app.ts
 * ==========================================================
 */
// 设置左侧菜单COLLAPSE 状态
export const SET_COLLAPSE_STATUS = 'SET_COLLAPSE_STATUS';
// 设置左侧菜单COLLAPSE 动作
export const SET_COLLAPSE_ACT = 'SET_COLLAPSE_ACT';
// 设置全局loading状态
export const SET_LOADING_STATUS = 'SET_LOADING_STATUS';
// 设置时间戳
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE';
// 设置当前设备类型
export const SET_DEVICE = 'SET_DEVICE';

// 设置导航模式
export const SET_LAYOUT = 'SET_LAYOUT';
// 设置是否显示面包屑
export const SET_BREADCRUMB_STATUS = 'SET_BREADCRUMB_STATUS';
// 设置是否使用多导航标签
export const SET_MULTIPLE_NAV_STATUS = 'SET_MULTIPLE_NAV_STATUS';
// 设置是否使用 keep-alive
export const SET_KEEPALIVE_STATUS = 'SET_KEEPALIVE_STATUS';
// 改变顶部导航别景色
export const SET_NAVBAR_BACKGROUND = 'SET_NAVBAR_BACKGROUND';
// 改变侧边栏背景色
export const SET_SIDEBAR_BACKGROUND = 'SET_SIDEBAR_BACKGROUND';
// 设置是否使用顶部导航
export const SET_HEADER_STATUS = 'SET_HEADER_STATUS';
// 设置是否使用侧边导航
export const SET_SIDEBAR_STATUS = 'SET_SIDEBAR_STATUS';

/**
 * ==========================================================
 * @description: multipleNav.ts
 * ==========================================================
 */
export const ADD_TAG_ONLY = 'ADD_TAG_ONLY'; // 添加多导航标签
export const ADD_CACHE_ONLY = 'ADD_CACHE_ONLY';
export const ADD_TAG_AND_CACHE = 'ADD_TAG_AND_CACHE'; // 添加多导航标签并缓存
export const SET_VISITED_VIEWS = 'SET_VISITED_VIEWS'; // 设置选中的路由的标签内容
export const DEL_TAG_AND_CACHE = 'DEL_TAG_AND_CACHE'; // 删除选中的导航标签并清除缓存
export const DEL_CACHE_ONLY = 'DEL_CACHE_ONLY'; // 清除缓存
export const DEL_TAG_ONLY = 'DEl_TAG_ONLY'; // 删除选中的导航标签
export const DEL_OTHER_TAG_AND_CACHE = 'DEL_OTHER_TAG_AND_CACHE'; // 删除当前标签外的其他标签
export const DEL_LEFT_TAG_AND_CACHE = 'DEL_LEFT_TAG_AND_CACHE'; // 删除当前标签左侧的其他标签
export const DEL_RIGHT_TAG_AND_CACHE = 'DEL_RIGHT_TAG_AND_CACHE'; // 删除当前标签右侧的其他标签
export const DEL_ALL_TAG_AND_CACHE = 'DEL_ALL_TAG_AND_CACHE'; // 删除所有标签和缓存

/**
 * ==========================================================
 * @description: permission.ts
 * ==========================================================
 */
// 格式化路由
export const GENERATE_ROUTES = 'GENERATE_ROUTES';

/**
 * ==========================================================
 * @description: research.ts
 * ==========================================================
 */
export const SET_DATA_INIT_STATE = 'SET_DATA_INIT_STATE'; // 设置重新调用数据初始化方法的标识
export const SET_DATA_UN_INIT_STATE = 'SET_DATA_UN_INIT_STATE';
export const DEL_DATA_INIT_STATE = 'DEL_DATA_INIT_STATE'; // 删除需要重新调用数据初始化方法的标识

/**
 * ==========================================================
 * @description: user.ts
 * ==========================================================
 */
// 退出登录
export const LOGIN_OUT = 'LOGIN_OUT';
// 获取菜单并设置菜单
export const SET_MENUS = 'SET_MENUS';
// 获取并设置后端返回的有权限的菜单和组件的code值
export const SET_MENU_AUTH_KEYS = 'SET_MENU_AUTH_KEYS';
// 获取用户当前登录的真实姓名
export const SET_USER_NAME = 'SET_USER_NAME';
// 获取用户当前登录的账号
export const SET_USER_REAL_NAME = 'SET_USER_REAL_NAME';
// 当前用户信息
export const SET_USER_INFO = 'SET_USER_INFO';
